import Recognizing from "./Recognizing"

export default Recognizing;
